module.exports = {"TXTWCL_Self_excluded":{"id":"TXTWCL_Self_excluded","defaultMessage":"Autoexclus"}}